var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircledClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .833A7.173 7.173 0 0115.167 8 7.173 7.173 0 018 15.167 7.173 7.173 0 01.833 8 7.173 7.173 0 018 .833zm0 1A6.174 6.174 0 001.833 8c0 3.4 2.767 6.167 6.167 6.167S14.167 11.4 14.167 8 11.4 1.833 8 1.833zM6.659 5.5l.082.069 1.437 1.437 1.438-1.437a.592.592 0 01.906.755l-.069.082-1.438 1.437 1.438 1.438a.592.592 0 01-.755.906l-.082-.068L8.178 8.68 6.74 10.12a.592.592 0 01-.906-.756l.068-.082L7.34 7.844 5.902 6.407A.592.592 0 016.66 5.5z",
    fill: "var(--gray-600)"
  })));
}
export default SvgCircledClose;